var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletedUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z",
    fill: "#EAF0F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 52c0 11.046-8.954 20-20 20a19.93 19.93 0 01-8.113-1.714l26.128-26.984A19.92 19.92 0 0172 52zm-37.639 9.435l26.501-27.37A19.918 19.918 0 0052 32c-11.046 0-20 8.954-20 20 0 3.412.855 6.625 2.361 9.435zM83 52c0 17.12-13.88 31-31 31-17.12 0-31-13.88-31-31 0-17.12 13.88-31 31-31 17.12 0 31 13.88 31 31z",
    fill: "#CCD3DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedUserAvatar);
export default __webpack_public_path__ + "static/media/deleted-user-avatar.eb9e9552ad96a6f7da8483e19704e09b.svg";
export { ForwardRef as ReactComponent };